import {SupportSlotAssignmentTypeEnum} from '../../model/support/slot/support-slot-assignment-type.enum';
import {SupportSlotCustomerAssignmentModel} from '../../model/support/slot/support-slot-customer-assignment.model';
import {SupportSlotDefinitionCustomerAssignmentModel} from '../../model/support/slot/support-slot-definition-customer-assignment.model';
import {SupportSlotDefinitionModel} from '../../model/support/slot/support-slot-definition.model';
import axios from '../axios';

export namespace SupportSlotsController {
  export type CreateSupportSlotDefinition = {
    weekday: number
    startTime: string
    endTime: string
    isGlobal: boolean
    validFrom: string
    validTo: string
  }

  export const createSupportSlotDefinition = async (req: CreateSupportSlotDefinition) =>
    (await axios.post(`/internal/support/slots/definitions`, req));

  export type UpdateSupportSlotDefinition = {
    startTime: string
    endTime: string
    validFrom: string
    validTo: string
  }

  export const updateSupportSlotDefinition = async (slotDefinitionId: string, version: number, req: UpdateSupportSlotDefinition) =>
    (await axios.put(`/internal/support/slots/definitions/${slotDefinitionId}?version=${version}`, req))

  export const deleteSupportSlotDefinition = async (slotDefinitionId: string, version: number) =>
    (await axios.delete(`/internal/support/slots/definitions/${slotDefinitionId}?version=${version}`))

  export const fetchSupportSlotDefinitions = async () =>
    (await axios.get<SupportSlotDefinitionModel[]>(`/internal/support/slots/definitions`));

  export const fetchSupportSlotDefinitionAssignments = async (slotDefinitionId: string): Promise<SupportSlotCustomerAssignmentModel[]> =>
    (await axios.get<SupportSlotCustomerAssignmentModel[]>(`/internal/support/slots/definitions/${slotDefinitionId}/assignments`)).data

  export type CreateSupportSlotAssignment = {
    slotDefinitionId: string
    planId: string
    assignmentType: SupportSlotAssignmentTypeEnum
  }

  export const createSupportSlotAssignment = async (req: CreateSupportSlotAssignment) =>
    (await axios.post(`/internal/support/slots/definitions/assignments`, req))

  export const deleteSupportSlotDefinitionAssignment = async (slotDefinitionAssignmentId: string, version: number) =>
    (await axios.delete(`/internal/support/slots/definitions/assignments/${slotDefinitionAssignmentId}?version=${version}`))

  export const fetchCustomerSlotDefinitions = async (organizationId: string) =>
    (await axios.get<SupportSlotDefinitionCustomerAssignmentModel[]>(`/internal/support/organizations/${organizationId}/slots/definitions/assignments`))

}